import cn from "classnames";
import React, { useCallback, useEffect, useRef, useState, useMemo } from "react";
import AuctionLot from "./AuctionLot";
import styles from "./auctionLots.module.scss";
import ListPagination from "./ListPagination";
export default function AuctionLots({ viewMode = "grid", strings, auctionUrl, auctionStatus, getItems, saveItemPositionState, showOnlyActive, forceShowWatchItem = false, biddingDisabled, removeItemOnWatchedRemoved, itemsPerPageLimit, }) {
    const [result, setResult] = useState({ total: 0, items: [], position: 1 });
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [error, setError] = useState();
    const [loading, setLoading] = useState(true);
    const activeFetch = useRef();
    const activePageHandler = useRef();
    const removeBoughtItem = (lotId) => {
        setResult({
            ...result,
            total: result.total - 1,
            items: result.items.filter(x => x.id != lotId),
        });
    };
    const fetchItems = useCallback(async (page) => {
        var _a;
        setLoading(true);
        let total = 0;
        window.scrollTo(0, 0);
        setResult({ total: 0, items: [], position: 1 });
        try {
            setError(undefined);
            const abortController = new AbortController();
            (_a = activeFetch.current) === null || _a === void 0 ? void 0 : _a.abort();
            activeFetch.current = abortController;
            const res = await getItems(page, abortController.signal);
            total = res.total;
            setResult(res);
            activePageHandler.current = page;
            setCurrentPage(Math.floor((res.position / itemsPerPageLimit) + 1));
            setTotalPages(Math.floor(total / itemsPerPageLimit) + 1);
        }
        catch (e) {
            setError(strings.auctionLot.rambaseItemsError);
            // if we aborted the fetch then we do nothing
            if (e.name !== "AbortError")
                throw e;
        }
        finally {
            // total -1 indicates that parent component is still in loading state
            setLoading(total == -1);
        }
    }, [getItems]);
    const hasPageControls = useMemo(() => {
        return !!result.nextPage || !!result.previousPage
            || !!result.firstPage || !!result.lastPage;
    }, [result]);
    const fetchPage = async (page) => {
        if (!page)
            return;
        await fetchItems(page);
    };
    const onWatchedRemove = (auctionItemId) => {
        if (!removeItemOnWatchedRemoved)
            return Promise.resolve();
        setResult({
            ...result,
            items: result.items.filter(x => x.id !== auctionItemId),
        });
        return Promise.resolve();
    };
    const renderPagination = (React.createElement(ListPagination, { currentPage: currentPage, totalPages: totalPages, firstPageDisabled: !result.firstPage, previousPageDisabled: !result.previousPage, nextPageDisabled: !result.nextPage, loadFirstPage: () => void fetchPage(result.firstPage), loadPreviousPage: () => void fetchPage(result.previousPage), loadNextPage: () => void fetchPage(result.nextPage), strings: strings.pagination }));
    useEffect(() => {
        void fetchItems(undefined);
    }, [fetchItems]);
    return (React.createElement("div", null,
        hasPageControls && (React.createElement("div", { className: styles.topPaginationContainer },
            " ",
            renderPagination,
            " ")),
        React.createElement("div", { className: cn(styles.auctionLots, styles[viewMode], "auction-content") },
            result.items.length > 0 &&
                result.items.map((item) => (React.createElement(AuctionLot, { key: item.id, bidItem: item, auctionUrl: auctionUrl, auctionStatus: auctionStatus, onWatchedRemove: onWatchedRemove, saveItemPositionState: saveItemPositionState, onBuyNow: removeBoughtItem, showOnlyActive: showOnlyActive, forceShowWatchItem: forceShowWatchItem, biddingDisabled: biddingDisabled, strings: strings.auctionLot }))),
            error &&
                React.createElement("span", { className: styles.emptyLabel }, error),
            !error && result.items.length === 0 && !loading && (React.createElement("span", { className: styles.emptyLabel }, strings.emptyList))),
        hasPageControls && (React.createElement("div", { className: styles.bottomPaginationContainer },
            " ",
            renderPagination,
            " "))));
}
